import React, { useCallback, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import styled from "styled-components/macro";

import { createSearchParams, Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import Modal from "../../../components/Modal";
import { InfoType, settingUsertype } from "../../../reducer/userpayloadtypes";
import axios from "axios";
import Switch from "react-switch";
const Container = styled.div`
  background-color: #fff;
  min-height: 100vh;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const FirstCon = styled.div`
  height: 86px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;

const FlexCon = styled.div`
  display: flex;
  padding: 0 30px;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;
    font-size: 16px;
  }

  .leftcon {
    display: flex;
    align-items: flex-start;
  }

  .secondtxt {
    color: #979797;
    font-size: 12px;
    top: 10%;
    position: relative;
  }

  .profilecon {
    background-color: #73972c;
    border: 0.5px solid #73972c;
    width: 80px;
    height: 35px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

const CrossLine = styled.div`
  display: flex;
  padding: 5px 0px;
  border: 1px solid lightgray;
  background-color: #f5f5f5;
  margin-top: 15px;
`;

const NotiSetting = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [pushYn, setPushYn] = useState<boolean>(false);
  const [feedPushYn, setFeedPushYn] = useState<boolean>(false);
  const [sensorPushYn, setSensorPushYn] = useState<boolean>(false);

  useEffect(() => {
    dispatch(userSlice.actions.Routerpath("/NotiSetting"));
  }, []);

  // 알림 설정 함수
  const switchchange = async (type: string) => {
    if (type === "pushYn") {
      let YN = "";

      if (pushYn === false) {
        YN = "Y";
      } else {
        YN = "N";
      }
      let data = {
        pushYn: YN,
      };
      const response = await axios.put(
        `ifactory/api/member/updatePushYn`,
        data
      );
      setPushYn((prev) => !prev);

      // 알림허용 전체 끌 때 하위 알림 꺼주기
      if (data.pushYn === "N") {
        let data = {
          feedPushYn: "N",
        };
        const response = await axios.put(
          `ifactory/api/member/updatePushYn`,
          data
        );

        setFeedPushYn(false);

        let datas = {
          sensorPushYn: "N",
        };
        const responses = await axios.put(
          `ifactory/api/member/updatePushYn`,
          datas
        );

        setSensorPushYn(false);
      }
    } else if (type === "feedPushYn") {
      if (pushYn === false) {
        // return alert("알림을 허용해주세요.");
        return confirmAlert({
          title: "알림을 허용해주세요.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }
      let YN = "";
      if (feedPushYn === false) {
        YN = "Y";
      } else {
        YN = "N";
      }

      let data = {
        feedPushYn: YN,
      };
      const response = await axios.put(
        `ifactory/api/member/updatePushYn`,
        data
      );

      setFeedPushYn((prev) => !prev);
    } else if (type === "sensorPushYn") {
      if (pushYn === false) {
        // return alert("알림을 허용해주세요.");
        return confirmAlert({
          title: "알림을 허용해주세요.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }
      let YN = "";
      if (sensorPushYn === false) {
        YN = "Y";
      } else {
        YN = "N";
      }
      let data = {
        sensorPushYn: YN,
      };
      const response = await axios.put(
        `ifactory/api/member/updatePushYn`,
        data
      );

      setSensorPushYn((prev) => !prev);
    }

    getNotiStatus();
  };

  // 알림 상태 불러는 함수
  const getNotiStatus = async () => {
    const response = await axios.get(`/ifactory/api/member/findmemberinfo`);

    console.log("get !!! response:", response.data);
    const pushYn = response.data.pushYn;
    const feedPushYn = response.data.feedPushYn;
    const sensorPushYn = response.data.sensorPushYn;

    if (pushYn === "N") {
      setPushYn(false);
    } else {
      setPushYn(true);
    }

    if (feedPushYn === "N") {
      setFeedPushYn(false);
    } else {
      setFeedPushYn(true);
    }

    if (sensorPushYn === "N") {
      setSensorPushYn(false);
    } else {
      setSensorPushYn(true);
    }
  };

  useEffect(() => {
    getNotiStatus();
  }, []);

  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate(-1);
            }}
          />
        </p>
        <p className="pagetit">알림설정</p>
      </PageTop>

      <FirstCon>
        <FlexCon>
          <div className="leftcon">
            <div>알림허용</div>
            <div className="secondtxt">알림허용을 전체 허용합니다.</div>
          </div>
          <Switch
            onChange={() => switchchange("pushYn")}
            checked={pushYn}
            uncheckedIcon={true}
            checkedIcon={true}
            onColor="#73972c"
          />
        </FlexCon>
      </FirstCon>
      <CrossLine></CrossLine>
      <FirstCon style={{ borderBottom: "1px solid lightgray" }}>
        <FlexCon>
          <div className="leftcon">
            <div>사료알람</div>
          </div>

          <Switch
            onChange={() => switchchange("feedPushYn")}
            checked={feedPushYn}
            uncheckedIcon={true}
            checkedIcon={true}
            onColor="#73972c"
          />
        </FlexCon>
      </FirstCon>
      <FirstCon style={{ borderBottom: "1px solid lightgray" }}>
        <FlexCon>
          <div className="leftcon">
            <div>센서알람</div>
          </div>
          <Switch
            onChange={() => switchchange("sensorPushYn")}
            checked={sensorPushYn}
            uncheckedIcon={true}
            checkedIcon={true}
            onColor="#73972c"
          />
        </FlexCon>
      </FirstCon>
    </Container>
  );
};

export default NotiSetting;
